import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";

// Import styles
import "./Input.scss";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("fr", fr);

const input = (props) => {
  let inputElement = null;
  let inputClasses = ["form-control"];

  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push("is-invalid");
  }

  if (!props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push("is-valid");
  }

  if (props.elementConfig.classes) {
    inputClasses.push(props.elementConfig.classes);
  }

  if (props.shouldValidate.isEuro) {
    inputClasses.push("field-euro");
  }

  if (!props.shouldValidate.required && props.value === "") {
    inputClasses = inputClasses.filter((cls) => cls !== "is-valid");
  }

  switch (props.elementType) {
    case "input":
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          name={props.elementConfig.name}
          readOnly={props.isReadOnly}
          onChange={props.changed}
          tabIndex={props.isReadOnly ? "-1" : "0"}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          name={props.elementConfig.name}
          readOnly={props.isReadOnly}
          onChange={props.changed}
          tabIndex={props.isReadOnly ? "-1" : "0"}
        />
      );
      break;
    case "select":
      inputElement = (
        <select
          className={inputClasses.join(" ")}
          value={props.value}
          name={props.elementConfig.name}
          disabled={props.isReadOnly}
          onChange={props.changed}
          tabIndex={props.isReadOnly ? "-1" : "0"}
        >
          {props.elementConfig.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    case "radio":
      inputElement = (
        <div className="form-group mb-0">
          {props.elementConfig.options.map((option, idx) => (
            <div
              className="form-check form-check-inline"
              key={props.elementConfig.name + "_" + idx}
            >
              <input
                className="form-check-input"
                type="radio"
                name={props.elementConfig.name}
                id={props.elementConfig.name + "_" + idx}
                value={option.value}
                onChange={props.changed}
                disabled={props.isReadOnly}
                checked={option.value === props.value}
                tabIndex={props.isReadOnly ? "-1" : "0"}
              />
              <label
                className="form-check-label"
                htmlFor={props.elementConfig.name + "_" + idx}
              >
                {option.displayValue}
              </label>
            </div>
          ))}
        </div>
      );
      break;
    case "datepicker":
      inputElement = (
        <DatePicker
          locale="fr"
          selected={props.value}
          onChange={(date) => props.selected(date)}
          placeholderText="01/01/1900"
          dateFormat="dd/MM/yyyy"
          className={inputClasses}
          readOnly={props.isReadOnly}
          tabIndex={props.isReadOnly ? "-1" : "0"}
        />
      );
      break;
    default:
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          name={props.elementConfig.name}
          readOnly={props.isReadOnly}
          onChange={props.changed}
          tabIndex={props.isReadOnly ? "-1" : "0"}
        />
      );
  }

  if (typeof props.label !== "undefined" && props.label !== "") {
    return (
      <div className="form-group">
        <label htmlFor={inputElement.id} className="col-form-label">
          {props.label}
        </label>
        <div>{inputElement}</div>
      </div>
    );
  } else if (props.shouldValidate.isEuro) {
    return (
      <div className="field-euro-wrapper">
        {inputElement}
        <span className="euro-text">€</span>
      </div>
    );
  } else {
    return inputElement;
  }
};

export default input;
